import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "closecircleo",
  "use": "closecircleo-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"closecircleo\"><title>closecircleo</title><path d=\"M11.211 4.789q-.164-.164-.398-.164t-.406.156L8.001 7.203 5.595 4.781q-.172-.156-.406-.156t-.398.164-.164.398.172.391L7.205 8l-2.406 2.422q-.172.156-.172.391t.164.398.398.164.406-.156l2.406-2.422 2.406 2.422q.172.156.406.156t.398-.164.164-.391-.172-.398L8.797 8l2.406-2.422q.172-.156.172-.391t-.164-.398zM8 0Q5.828 0 3.984 1.07T1.07 3.984 0 8t1.07 4.016 2.914 2.914T8 16t4.016-1.07 2.914-2.914T16 8t-1.07-4.016-2.914-2.914T8 0zm4.859 12.859q-.953.953-2.188 1.469-1.266.547-2.672.547t-2.672-.531q-1.234-.531-2.188-1.484T1.67 10.672Q1.123 9.406 1.123 8t.531-2.672q.531-1.234 1.484-2.188t2.188-1.469q1.266-.547 2.672-.547t2.672.531q1.234.531 2.188 1.484t1.469 2.188q.547 1.266.547 2.672t-.531 2.672q-.531 1.234-1.484 2.188z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/icons/closecircleo.svg
// module id = 158
// module chunks = 0